import React, { useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Alert, Box, Container, Link, Paper, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Input from '../components/common/Input';
import Button from '../components/common/Button';
import PublicNavbar from '../components/public/PublicNavbar';
import authService from '../services/auth';
import { publicLink, focusRing } from '../components/public/landingStyles';

const ResetPassword: React.FC = () => {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token') || '';
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const formik = useFormik({
    initialValues: { password: '' },
    validationSchema: Yup.object({
      password: Yup.string().min(8, 'At least 8 characters').required('Password is required'),
    }),
    onSubmit: async (values) => {
      setError('');
      try {
        await authService.resetPassword(token, values.password);
        setDone(true);
      } catch {
        setError('This reset link is invalid or has expired.');
      }
    },
  });

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <PublicNavbar />
      <Container id="main" component="main" tabIndex={-1} maxWidth="sm" sx={{ py: 6, minWidth: 0 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 2 }}>
            Choose a new password
          </Typography>
          {done ? (
            <Alert severity="success">
              Password updated. <Link component={RouterLink} to="/login" sx={{ ...publicLink, ...focusRing }}>Sign in</Link>
            </Alert>
          ) : (
            <form onSubmit={formik.handleSubmit}>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              {!token && <Alert severity="warning" sx={{ mb: 2 }}>This page needs a reset link from your email.</Alert>}
              <Input
                label="New password"
                name="password"
                type="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password ? formik.errors.password : undefined}
                required
              />
              <Button type="submit" variant="contained" fullWidth disabled={!token} loading={formik.isSubmitting}>
                Update password
              </Button>
            </form>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default ResetPassword;
